import { useEffect, useState } from 'react';
import QUESTION_TYPE_MAP from '../../../../../../apps/frontend/src/utils/variables';
import QuestionJourneyPill from '../QuestionJourneyPill';
import SolutionDrawer from '../../../components/drawers/SolutionDrawer';

export default function AllQuestionAnalysisChart({
  allQuestionAnalysis,
  selectedSubject,
  showAttemptAnalysis,
  questionAttemptAnalysis,
}) {
  const [subjectQuestions, setSubjectQuestions] = useState(null);
  const [showQuestionDrawer, setShowQuestionDrawer] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [questionNumbers, setQuestionNumbers] = useState([]);

  useEffect(() => {
    if (!allQuestionAnalysis || !selectedSubject) return;
    const tempQuestionsArray = [];
    if (selectedSubject.title === 'All Subjects') {
      allQuestionAnalysis?.forEach((item) => {
        item?.types?.forEach((type) => {
          type?.answers?.forEach((answer) => {
            tempQuestionsArray.push(answer?.questionNumber);
          });
        });
      });
      setQuestionNumbers(tempQuestionsArray);
      setSubjectQuestions(allQuestionAnalysis);
      return;
    }
    const selectedSubjectQuestions = allQuestionAnalysis.filter((item) => item.subject === selectedSubject.title);
    selectedSubjectQuestions?.forEach((item) => {
      item?.types?.forEach((type) => {
        type?.answers?.forEach((answer) => {
          tempQuestionsArray.push(answer?.questionNumber);
        });
      });
    });
    setQuestionNumbers(tempQuestionsArray);
    setSubjectQuestions(selectedSubjectQuestions);
  }, [selectedSubject]);

  const handleQuestionClick = (item) => {
    setShowQuestionDrawer(true);
    setSelectedQuestion(item?.questionNumber);
  };

  return (
    <div className="p-6 flex flex-col gap-4 border border-t-0 border-[var(--q3-stroke-light)] rounded-b-xl">
      {subjectQuestions?.map((item, index) => (
        <div className="flex flex-col">
          {selectedSubject.title === 'All Subjects' && (
            <div className={`flex flex-row items-center gap-2 ${index > 0 && 'mt-6'}`}>
              <img src={item.icon} alt={item.title} />
              <p style={{ color: item.color }}>{item.subject}</p>
            </div>
          )}
          {item?.types?.map((type) => (
            <div className="text-xs text-[var(--q3-neutral-light)] font-medium pt-4">
              {QUESTION_TYPE_MAP[type.type]}
              <div className="flex flex-row flex-wrap gap-3 pt-3">
                {type?.answers?.map((answer) => {
                  answer.attemptOverview = questionAttemptAnalysis[answer.questionNumber];
                  return (
                    <div onClick={() => handleQuestionClick(answer)}>
                      <QuestionJourneyPill item={answer} showAttemptAnalysis={showAttemptAnalysis} />
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      ))}
      {showQuestionDrawer && selectedQuestion && (
        <SolutionDrawer
          qNo={selectedQuestion}
          questionNumbers={questionNumbers}
          isOpen={showQuestionDrawer}
          handleClose={() => {
            setSelectedQuestion(null);
            showQuestionDrawer(false);
          }}
        />
      )}
    </div>
  );
}
